<app-full-page-loader *ngIf="isLoading()"></app-full-page-loader>
<router-outlet></router-outlet>